<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<!-- stepper -->
<app-place-ad-stepper *ngIf="!loading && !user"></app-place-ad-stepper>

<!-- form -->
<div class="layout-container">
	<div class="row mx-0 justify-content-between my-4">
		<div class="col-auto px-0">
			<span class="fs-24px fw-500">{{ locale.translations['place-ad']['n695'] }}</span>
		</div>
		<div
			class="col-auto cursor-pointer d-flex align-items-center"
			[ngClass]="{ 'text-start': locale.lang !== 'en', 'text-end': locale.lang === 'en' }"
			(click)="onOpenWhatsapp()"
		>
			<img [src]="'/assets/images/payment/whatsapp.svg' | s3Image" [ngClass]="{ 'me-2': locale.lang === 'en', 'ms-2': locale.lang !== 'en' }" />
			<span class="help fg-purple">{{ locale.translations['whats-new']['new-auth']['n572'] }}</span>
		</div>
	</div>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<!-- STAGE 1 - PHONE NUMBER -->
		<div class="row">
			<div class="col-12">
				<span class="fg-grey">{{ locale.translations['place-ad']['n696'] }}</span>
				<mat-form-field
					class="v2 new my-2 fs-14px"
					[ngClass]="{ phone_wrap: locale.lang === 'en', phone_wrap_rev: locale.lang !== 'en' }"
					appearance="outline"
					hideRequiredMarker
				>
					<input
						#PhoneInput
						matInput
						required
						dir="ltr"
						type="tel"
						pattern="[0-9]{0,}"
						formControlName="phone"
						[maxLength]="11"
						(keyup)="onPhoneKeyUp()"
						(keypress)="isNumberKey($event)"
						class="fg-black"
						(focus)="PhoneInput.setSelectionRange(PhoneInput.value.length, PhoneInput.value.length)"
						[ngStyle]="{
							'text-align': locale.lang === 'en' ? 'left' : 'right'
						}"
						formControlName="phone"
						placeholder="07XXXXXXXXX"
					/>
				</mat-form-field>
				<div
					class="col-12 d-flex px-0 fg-light-grey"
					[ngClass]="{
						red: form.controls.phone.touched && (form.controls.phone.hasError('minlength') || form.controls.phone.hasError('required'))
					}"
				>
					<mat-icon class="fs-15px mt-3px mat-icon-rtl-mirror">info</mat-icon>

					<span class="fs-11px">{{ locale.translations['whats-new']['new-auth']['n537'] }}</span>
				</div>
			</div>
		</div>
		<!-- END STAGE 1 -->

		<!-- STAGE 2 - Select Phone Type -->
		<div class="row mt-3">
			<div class="col-12">
				<span class="fg-grey">{{ locale.translations['place-ad']['n697'] }}</span>
			</div>
		</div>

		<div class="row mx-0 mb-4 mt-2">
			<div class="col-6 px-0">
				<mat-checkbox class="checkbox-margin" formControlName="contactTypeWhatsapp">
					<span class="checkbox-content">
						<img [src]="'/assets/icons/whatsapp-3.svg' | s3Image" class="phone-option-img" alt="Whatsapp" />
						{{ locale.translations['ads']['ad']['n297'] }}
					</span>
				</mat-checkbox>
			</div>
			<div class="col-6 px-1">
				<mat-checkbox class="checkbox-margin" formControlName="contactTypeViber">
					<span class="checkbox-content">
						<img [src]="'/assets/icons/viber.svg' | s3Image" class="phone-option-img" alt="Viber" />
						{{ locale.translations['ads']['ad']['n298'] }}
					</span>
				</mat-checkbox>
			</div>
		</div>
		<!-- END STAGE 2 -->

		<!-- STAGE 3 - CATEGORY && SUBCATEGORY-->

		<div class="row mb-5px" *ngIf="(user && user['userType'] !== '1') || !user">
			<div class="col-12 fg-grey mb-2">
				{{ locale.translations['place-ad']['category']['n57'] }}
			</div>
			<div class="col-12">
				<mat-form-field appearance="outline" class="v2 fs-14px" hideRequiredMarker (click)="autoFocus()">
					<mat-select
						required
						placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['place-ad']['category']['n58'] }}"
						(selectionChange)="onCategorySelection($event)"
						(closed)="onClearSearch(searchTextCat)"
						formControlName="category"
					>
						<mat-form-field appearance="standard" class="search-field">
							<input
								matInput
								type="text"
								[formControl]="searchTextCat"
								id="searchbox"
								placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['place-ad']['category']['n58'] }}"
							/>
						</mat-form-field>
						<mat-option *ngFor="let category of categories | filterText : searchTextCat.value" value="{{ category['id'] }}">
							{{ category['name'] }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="form.controls.category.hasError('required')">
						{{ locale.translations['place-ad']['category']['n58'] }} {{ locale.translations['payment']['n421'] }}
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="row mb-5px" *ngIf="subcategories.length >= 1">
			<div class="col-12 fg-grey mb-2">{{ locale.translations['place-ad']['n479'] }}</div>
			<div class="col-12">
				<mat-form-field class="v2 fs-14px" appearance="outline" hideRequiredMarker (click)="autoFocus()">
					<mat-select
						required
						placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['place-ad']['category']['n59'] }}"
						(selectionChange)="onSubcategorySelection($event)"
						(closed)="onClearSearch(searchTextSubCat)"
						formControlName="subcategory"
					>
						<mat-form-field appearance="standard" class="search-field">
							<input
								matInput
								type="text"
								[formControl]="searchTextSubCat"
								id="searchbox"
								placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['place-ad']['category']['n59'] }}"
							/>
						</mat-form-field>
						<mat-option *ngFor="let subcategory of subcategories | filterText : searchTextSubCat.value" value="{{ subcategory['id'] }}">
							{{ subcategory.name }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="form.controls.subcategory.hasError('required')">
						{{ locale.translations['place-ad']['category']['n59'] }} {{ locale.translations['payment']['n421'] }}
					</mat-error>
				</mat-form-field>
			</div>
		</div>
		<!-- STAGE 3 END-->

		<!--STAGE PHOTOS-->
		<div class="row mx-0 mb-4">
			<div class="col-12 px-0">
				<button
					mat-stroked-button
					id="uploader"
					(click)="fileExplorer.value = ''; fileExplorer.click()"
					color="primary"
					type="button"
					class="add-image-button fw-400 fs-14px"
					[disabled]="images.length >= 10 || loading || !form.get('subcategory').value"
					id="n77"
				>
					<mat-icon class="mx-2">image</mat-icon>
					{{ locale.translations['place-ad']['photos']['n60'] }}
				</button>
				<input type="file" accept="image/jpg,image/jpeg,image/png,image/webp" (change)="onImageFileSelection($event)" multiple hidden #fileExplorer />
			</div>
		</div>
		<div class="row mx-0">
			<div class="col-md-6 col-sm-12 total-image px-0 mb-4" *ngFor="let image of images; let i = index" [ngClass]="{ 'ms-24px': i % 2 === 1 }">
				<!-- set image as cover -->
				<button mat-button type="button" color="primary" class="image-cover n114 n115" (click)="onImageCover(i)" [disabled]="!imagesUploaded()">
					<mat-icon>{{ coverImage === image['uploadID'] ? 'star' : 'star_border' }}</mat-icon>
					<span>
						{{
							coverImage === image['uploadID']
								? locale.translations['place-ad']['photos']['n115']
								: locale.translations['place-ad']['photos']['n114']
						}}
					</span>
				</button>

				<!-- progress bar -->
				<mat-progress-bar class="preserve" mode="determinate" [value]="image['progress']"></mat-progress-bar>

				<!-- thumbnail -->
				<img #adImage class="preview {{ image['progress'] !== 100 ? 'loading' : '' }}" [src]="image['url']" />
				<div class="d-flex flex-row justify-content-between image-edit">
					<div>
						<!-- remove image -->
						<button
							mat-button
							color="warn"
							type="button"
							class="image-delete n85"
							(click)="onImageDelete(i)"
							[disabled]="!imagesUploaded()"
							[disableRipple]="true"
						>
							<mat-icon
								[ngClass]="{ 'marg-left': locale.lang === 'en', 'marg-right': locale.lang === 'ku' || locale.lang === 'ar' }"
								color="warn"
							>
								delete
							</mat-icon>
							<span class="fs-14px">{{ locale.translations['user']['user-ads']['n85'] }}</span>
						</button>
					</div>
					<div>
						<button mat-button type="button" class="image-delete image-rotatn" (click)="rotateImage($event, i)" [disableRipple]="true">
							<img [src]="'/assets/images/rotate icon.svg' | s3Image" class="image-rotate" />
							<span class="fs-14px">{{ locale.translations['place-ad']['photos']['n165'] }}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
		<!--STAGE PHOTOS END-->

		<!--STAGE 4 DESCRIPTION -->

		<ng-container *ngIf="images.length > 0 && form.get('category').valid && form.get('subcategory').valid">
			<div class="row mx-0">
				<div
					class="col-12 mb-4 px-0"
					*ngIf="
						form.get('subcategory').value !== '291' &&
						this.form.get('subcategory').value !== '302' &&
						this.form.get('subcategory').value !== '303' &&
						this.form.get('subcategory').value !== '304' &&
						this.form.get('subcategory').value !== '305' &&
						this.form.get('subcategory').value !== '306' &&
						this.form.get('subcategory').value !== '307' &&
						this.form.get('subcategory').value !== '308' &&
						this.form.get('subcategory').value !== '309' &&
						this.form.get('subcategory').value !== '310' &&
						this.form.get('subcategory').value !== '311' &&
						this.form.get('subcategory').value !== '312' &&
						this.form.get('subcategory').value !== '313' &&
						this.form.get('subcategory').value !== '365' &&
						this.form.get('subcategory').value !== '366' &&
						this.form.get('subcategory').value !== '367' &&
						this.form.get('subcategory').value !== '370' &&
						this.form.get('subcategory').value !== '371' &&
						this.form.get('subcategory').value !== '372' &&
						this.form.get('subcategory').value !== '373'
					"
				>
					<span class="fg-grey mb-2 d-flex">{{ locale.translations['place-ad']['description']['n63'] }}</span>
					<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker>
						<input matInput required formControlName="title" placeholder="{{ locale.translations['place-ad']['description']['n63'] }}" />
					</mat-form-field>
					<div class="row mx-0 mt-4px d-flex flex-row">
						<div
							class="col-auto d-flex px-0 fg-light-grey"
							[ngClass]="{
								red:
									form.controls.title.touched &&
									(form.controls.title.hasError('minlength') ||
										form.controls.title.hasError('required') ||
										form.controls.title.hasError('maxlength'))
							}"
						>
							<mat-icon class="fs-15px mt-3px mat-icon-rtl-mirror">info</mat-icon>

							<span class="fs-11px">{{ locale.translations['place-ad']['n701'] }}</span>
						</div>

						<div
							class="col-auto px-0 fg-light-grey"
							[ngClass]="{
								red:
									form.controls.title.touched &&
									(form.controls.title.hasError('minlength') ||
										form.controls.title.hasError('required') ||
										form.controls.title.hasError('maxlength')),
								'ms-auto': locale.lang === 'en',
								'me-auto': locale.lang !== 'en'
							}"
						>
							<span class="fs-11px">{{ form.get('title').value?.length || 0 }} / 150</span>
						</div>
					</div>
				</div>

				<!-- electronic details -->
				<ng-container
					*ngIf="
						form.get('category').value === '16' &&
						(form.get('subcategory').value === '302' ||
							form.get('subcategory').value === '303' ||
							form.get('subcategory').value === '304' ||
							form.get('subcategory').value === '305' ||
							form.get('subcategory').value === '306' ||
							form.get('subcategory').value === '307' ||
							form.get('subcategory').value === '308' ||
							form.get('subcategory').value === '309' ||
							form.get('subcategory').value === '310' ||
							form.get('subcategory').value === '311' ||
							form.get('subcategory').value === '312' ||
							form.get('subcategory').value === '313' ||
							form.get('subcategory').value === '365' ||
							form.get('subcategory').value === '366' ||
							form.get('subcategory').value === '367' ||
							form.get('subcategory').value === '370' ||
							form.get('subcategory').value === '371' ||
							form.get('subcategory').value === '372' ||
							form.get('subcategory').value === '373')
					"
				>
					<div class="col-6 px-1 mb-3">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n271'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<mat-select
								required
								(selectionChange)="onBrandSelection($event)"
								(closed)="onClearSearch(searchTextBrand)"
								formControlName="eBrand"
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n271'] }}"
							>
								<mat-form-field appearance="standard" class="search-field">
									<input
										matInput
										type="text"
										[formControl]="searchTextBrand"
										id="searchbox"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n271'] }}"
									/>
								</mat-form-field>
								<mat-option *ngFor="let brand of electronicData['brands'] | filterText : searchTextBrand.value" value="{{ brand['id'] }}">
									{{ brand['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="form.controls.eBrand.hasError('required') && form.controls.eBrand.touched">
							{{ locale.translations['ads']['filter']['n271'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>

					<div class="col-6 px-1 mb-3">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n27'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<!-- <mat-label>{{ locale.translations['ads']['filter']['n27'] }}</mat-label> -->
							<mat-select
								formControlName="eModel"
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n27'] }}"
								(closed)="onClearSearch(searchTextModel)"
							>
								<mat-form-field appearance="standard" class="search-field">
									<input
										matInput
										type="text"
										[formControl]="searchTextModel"
										id="searchbox"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n27'] }}"
									/>
								</mat-form-field>
								<mat-option *ngFor="let model of models | filterText : searchTextModel.value" value="{{ model['id'] }}">
									{{ model['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="form.get('eModel').value === null && form.get('eModel').touched">
							{{ locale.translations['ads']['filter']['n27'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>

					<div class="col-6 px-1 mb-3">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n31'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<mat-select
								formControlName="eColor"
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n31'] }}"
								(closed)="onClearSearch(searchTextColor)"
							>
								<mat-form-field class="search-field" appearance="standard">
									<input
										matInput
										type="text"
										id="searchbox"
										[formControl]="searchTextColor"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n31'] }}"
									/>
								</mat-form-field>
								<mat-option *ngFor="let color of electronicData['colors'] | filterText : searchTextColor.value" value="{{ color['id'] }}">
									{{ color['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="form.controls.eColor.hasError('required') && form.controls.eColor.touched">
							{{ locale.translations['ads']['filter']['n31'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>
				</ng-container>

				<ng-container
					*ngIf="
						form.get('category').value === '16' &&
						(form.get('subcategory').value === '302' ||
							form.get('subcategory').value === '303' ||
							form.get('subcategory').value === '304' ||
							form.get('subcategory').value === '305' ||
							form.get('subcategory').value === '306' ||
							form.get('subcategory').value === '311')
					"
				>
					<div class="col-6 px-1 mb-3" id="n272">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n272'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<mat-select
								required
								formControlName="eStorage"
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n272'] }}"
								(closed)="onClearSearch(searchTextStorage)"
							>
								<mat-form-field appearance="standard" class="search-field">
									<input
										matInput
										type="text"
										[formControl]="searchTextStorage"
										id="searchbox"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n272'] }}"
									/>
								</mat-form-field>
								<mat-option
									*ngFor="let storage of electronicData['storage'] | filterText : searchTextStorage.value"
									value="{{ storage['id'] }}"
								>
									{{ storage['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="!form.get('eStorage').value && form.get('eStorage').touched">
							{{ locale.translations['ads']['filter']['n272'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>
				</ng-container>
				<ng-container
					*ngIf="form.get('category').value === '16' && (form.get('subcategory').value === '304' || form.get('subcategory').value === '305')"
				>
					<div class="col-6 px-1 mb-3" id="n273">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n273'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<mat-select
								required
								formControlName="eMemory"
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n273'] }}"
								(closed)="onClearSearch(searchTextMemory)"
							>
								<mat-form-field appearance="standard" class="search-field">
									<input
										matInput
										type="text"
										[formControl]="searchTextMemory"
										id="searchbox"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n273'] }}"
									/>
								</mat-form-field>
								<mat-option *ngFor="let memory of electronicData['memory'] | filterText : searchTextMemory.value" value="{{ memory['id'] }}">
									{{ memory['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="!form.get('eMemory').value && form.get('eMemory').touched">
							{{ locale.translations['ads']['filter']['n273'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>
					<div class="col-6 px-1 mb-3" id="n275">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n275'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<mat-select
								required
								formControlName="eProcessor"
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n275'] }}"
								(closed)="onClearSearch(searchTextProcessor)"
							>
								<mat-form-field class="search-field" appearance="standard" hideRequiredMarker>
									<input
										matInput
										type="text"
										[formControl]="searchTextProcessor"
										id="searchbox"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n275'] }}"
									/>
								</mat-form-field>
								<mat-option
									*ngFor="let processor of electronicData['processor'] | filterText : searchTextProcessor.value"
									value="{{ processor['id'] }}"
								>
									{{ processor['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="!form.get('eProcessor').value && form.get('eProcessor').touched">
							{{ locale.translations['ads']['filter']['n275'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>
					<div class="col-6 px-1 mb-3" id="n276">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n276'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<mat-select
								required
								formControlName="eGraphic"
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n276'] }}"
								(closed)="onClearSearch(searchTextGraphics)"
							>
								<mat-form-field class="search-field" appearance="standard" hideRequiredMarker>
									<input
										matInput
										type="text"
										[formControl]="searchTextGraphics"
										id="searchbox"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n276'] }}"
									/>
								</mat-form-field>
								<mat-option
									*ngFor="let graphic of electronicData['graphics'] | filterText : searchTextGraphics.value"
									value="{{ graphic['id'] }}"
								>
									{{ graphic['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="!form.get('eGraphic').value && form.get('eGraphic').touched">
							{{ locale.translations['ads']['filter']['n276'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>
				</ng-container>

				<ng-container
					*ngIf="form.get('category').value === '16' && (form.get('subcategory').value === '302' || form.get('subcategory').value === '303')"
				>
					<div class="col-6 px-1 mb-3" id="n274">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n274'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<mat-select
								required
								formControlName="eNetwork"
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n274'] }}"
								(closed)="onClearSearch(searchTextNetwork)"
							>
								<mat-form-field class="search-field" appearance="standard" hideRequiredMarker>
									<input
										matInput
										type="text"
										[formControl]="searchTextNetwork"
										id="searchbox"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{
											locale.translations['place-ad']['category']['n59']
										}}"
									/>
								</mat-form-field>
								<mat-option
									*ngFor="let network of electronicData['network'] | filterText : searchTextNetwork.value"
									value="{{ network['id'] }}"
								>
									{{ network['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="!form.get('eNetwork').value && form.get('eNetwork').touched">
							{{ locale.translations['ads']['filter']['n274'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>
				</ng-container>

				<!-- motor details -->
				<ng-container *ngIf="form.get('category').value === '15' && form.get('subcategory').value === '291'">
					<div class="col-6 px-1 mb-3" id="n65">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n26'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<mat-select
								required
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n26'] }}"
								(selectionChange)="onMakeSelection($event)"
								(closed)="onClearSearch(searchTextMake)"
								formControlName="make"
							>
								<mat-form-field appearance="standard" class="search-field">
									<input
										matInput
										type="text"
										[formControl]="searchTextMake"
										id="searchbox"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n26'] }}"
									/>
								</mat-form-field>
								<mat-option *ngFor="let make of motorData['makes'] | filterText : searchTextMake.value" value="{{ make['id'] }}">
									{{ make['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="form.controls.make.hasError('required') && form.controls.make.touched">
							{{ locale.translations['ads']['filter']['n26'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>

					<div class="col-6 px-1 mb-3" id="n66">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n27'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<!-- <mat-label>{{ locale.translations['place-ad']['description']['motor']['n66'] }}</mat-label> -->
							<mat-select
								required
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n27'] }}"
								formControlName="model"
								(closed)="onClearSearch(searchTextModel)"
							>
								<mat-form-field appearance="standard" class="search-field">
									<input
										matInput
										type="text"
										[formControl]="searchTextModel"
										id="searchbox"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n27'] }}"
									/>
								</mat-form-field>
								<mat-option *ngFor="let model of models | filterText : searchTextModel.value" value="{{ model['id'] }}">
									{{ model['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="form.controls.model.hasError('required') && form.controls.model.touched">
							{{ locale.translations['ads']['filter']['n27'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>

					<div class="col-6 px-1 mb-3" id="n71">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n31'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<mat-select
								required
								formControlName="color"
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n31'] }}"
								(closed)="onClearSearch(searchTextColor)"
							>
								<mat-form-field class="search-field" appearance="standard">
									<input
										matInput
										type="text"
										id="searchbox"
										[formControl]="searchTextColor"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n31'] }}"
									/>
								</mat-form-field>
								<mat-option *ngFor="let color of motorData['color'] | filterText : searchTextColor.value" value="{{ color['id'] }}">
									{{ color['name'] }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px mt-2px" *ngIf="form.controls.color.hasError('required') && form.controls.color.touched">
							{{ locale.translations['ads']['filter']['n31'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>

					<div class="col-6 px-1 mb-3" id="n67">
						<span class="fg-grey mb-2 d-flex">{{ locale.translations['ads']['filter']['n28'] }}</span>
						<mat-form-field appearance="outline" class="v2 new fs-14px" hideRequiredMarker (click)="autoFocus()">
							<!-- <mat-label>{{ locale.translations['place-ad']['description']['motor']['n67'] }}</mat-label> -->
							<mat-select
								required
								formControlName="year"
								placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['ads']['filter']['n28'] }}"
								(closed)="onClearSearch(searchTextYear)"
							>
								<mat-form-field class="search-field" appearance="standard" hideRequiredMarker>
									<input
										matInput
										type="text"
										[formControl]="searchTextYear"
										id="searchbox"
										placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n28'] }}"
									/>
								</mat-form-field>
								<mat-option *ngFor="let year of motorData['years'] | filterText : searchTextYear.value" value="{{ year }}">
									{{ year }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-error class="fs-11px fs-11px mt-2px" *ngIf="form.controls.year.hasError('required') && form.controls.year.touched">
							{{ locale.translations['ads']['filter']['n28'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</div>
				</ng-container>

				<div class="col-12 px-0 mb-3" id="n64">
					<span class="fg-grey mb-2 d-flex">{{ locale.translations['place-ad']['description']['n64'] }}</span>
					<mat-form-field appearance="outline" class="v2 new-description fs-14px" hideRequiredMarker>
						<textarea
							matInput
							cdkTextareaAutosize
							#autosize="cdkTextareaAutosize"
							cdkAutosizeMinRows="5"
							cdkAutosizeMaxRows="10"
							formControlName="description"
							placeholder="{{ locale.translations['place-ad']['description']['n62'] }}"
						></textarea>

						<!--  description validation message -->
					</mat-form-field>
					<div class="row mx-0 d-flex flex-row mt-14px">
						<div
							class="col-auto d-flex px-0 fg-light-grey"
							[ngClass]="{
								red:
									form.controls.description.touched &&
									(form.controls.description.hasError('minlength') ||
										form.controls.description.hasError('required') ||
										form.controls.description.hasError('maxlength'))
							}"
						>
							<mat-icon class="mat-icon-rtl-mirror mt-3px fs-15px">info</mat-icon>
							<span class="fs-11px">{{ locale.translations['place-ad']['n700'] }}</span>
						</div>

						<div
							class="col-auto px-0 fg-light-grey"
							[ngClass]="{
								red:
									form.controls.description.touched &&
									(form.controls.description.hasError('minlength') ||
										form.controls.description.hasError('required') ||
										form.controls.description.hasError('maxlength')),
								'ms-auto': locale.lang === 'en',
								'me-auto': locale.lang !== 'en'
							}"
						>
							<span class="d-flex flex-column fs-11px align-items-end">{{ form.get('description').value?.length || 0 }} / 5000</span>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		<!--STAGE 4 END -->

		<!--STAGE 5 PRICE -->
		<ng-container
			*ngIf="
				(form.get('description').valid &&
					form.get('subcategory').value !== '291' &&
					this.form.get('subcategory').value !== '302' &&
					this.form.get('subcategory').value !== '303' &&
					this.form.get('subcategory').value !== '304' &&
					this.form.get('subcategory').value !== '305' &&
					this.form.get('subcategory').value !== '306' &&
					this.form.get('subcategory').value !== '307' &&
					this.form.get('subcategory').value !== '308' &&
					this.form.get('subcategory').value !== '309' &&
					this.form.get('subcategory').value !== '310' &&
					this.form.get('subcategory').value !== '311' &&
					this.form.get('subcategory').value !== '312' &&
					this.form.get('subcategory').value !== '313' &&
					this.form.get('subcategory').value !== '365' &&
					this.form.get('subcategory').value !== '366' &&
					this.form.get('subcategory').value !== '367' &&
					this.form.get('subcategory').value !== '370' &&
					this.form.get('subcategory').value !== '371' &&
					this.form.get('subcategory').value !== '372' &&
					this.form.get('subcategory').value !== '373') ||
				(form.get('description').valid &&
					form.get('category').value === '15' &&
					form.get('subcategory').value === '291' &&
					form.get('make').valid &&
					form.get('model').valid &&
					form.get('year').valid &&
					form.get('color').valid) ||
				(form.get('description').valid &&
					form.get('category').value === '16' &&
					(form.get('subcategory').value === '302' ||
						form.get('subcategory').value === '303' ||
						form.get('subcategory').value === '304' ||
						form.get('subcategory').value === '305' ||
						form.get('subcategory').value === '306' ||
						form.get('subcategory').value === '307' ||
						form.get('subcategory').value === '308' ||
						form.get('subcategory').value === '309' ||
						form.get('subcategory').value === '310' ||
						form.get('subcategory').value === '311' ||
						form.get('subcategory').value === '312' ||
						form.get('subcategory').value === '313' ||
						form.get('subcategory').value === '365' ||
						form.get('subcategory').value === '366' ||
						form.get('subcategory').value === '367' ||
						form.get('subcategory').value === '370' ||
						form.get('subcategory').value === '371' ||
						form.get('subcategory').value === '372' ||
						form.get('subcategory').value === '373') &&
					form.get('eBrand').valid &&
					form.get('eModel').valid)
			"
		>
			<div class="row mb-4">
				<div class="col-12 mb-2 d-flex fg-grey">
					{{ locale.translations['place-ad']['price']['n73'] }}
				</div>

				<div class="col-12">
					<mat-form-field appearance="outline" class="v2 fs-14px" hideRequiredMarker>
						<input
							matInput
							id="priceInput"
							type="tel"
							pattern="[0-9]{0,}"
							formControlName="price"
							(keyup)="onPriceKeyUp()"
							placeholder="{{ locale.translations['place-ad']['n699'] }}"
						/>
						<span matPrefix *ngIf="locale.lang === 'en' ? 'ltr' : 'rtl'">&#36;</span>
						<mat-hint [ngClass]="{ red: form.controls.price.touched && (form.controls.price.hasError('maxlength') || !form.get('price').valid) }">
							{{ locale.translations['place-ad']['n438'] }}
						</mat-hint>
					</mat-form-field>
				</div>
			</div>
		</ng-container>
		<!--STAGE 5 END-->

		<!-- STAGE 6 - LOCATION -->
		<ng-container *ngIf="form.get('price').valid">
			<div class="row">
				<div class="col-12 mb-2 fg-grey">
					{{ locale.translations['place-ad']['location']['n75'] }}
				</div>

				<div class="col-12">
					<mat-form-field appearance="outline" class="v2 fs-14px" hideRequiredMarker (click)="autoFocus()">
						<mat-select
							required
							placeholder="{{ locale.translations['place-ad']['location']['n75'] }}"
							formControlName="location"
							(closed)="onClearSearch(searchTextLocation)"
						>
							<mat-form-field appearance="standard" class="search-field">
								<input
									matInput
									type="text"
									id="searchbox"
									[formControl]="searchTextLocation"
									placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n25'] }}"
								/>
							</mat-form-field>

							<!-- popular locations -->
							<mat-option *ngFor="let location of popularLocations | filterText : searchTextLocation.value" value="{{ location['id'] }}">
								{{ location['name'] }}
							</mat-option>

							<!-- divider -->
							<mat-divider style="margin: 0"></mat-divider>

							<!-- all locations -->
							<mat-option *ngFor="let location of locations | filterText : searchTextLocation.value" value="{{ location['id'] }}">
								{{ location['name'] }}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="form.controls.location.hasError('required')">
							{{ locale.translations['ads']['filter']['n25'] }} {{ locale.translations['payment']['n421'] }}
						</mat-error>
					</mat-form-field>
				</div>
			</div>
		</ng-container>
		<!--STAGE 6 END-->

		<!-- STAGE 7 - FINISH -->
		<div class="row mb-4">
			<div class="col-12">
				<button
					mat-flat-button
					color="primary"
					type="submit"
					class="finish fs-14px fw-500"
					[disabled]="!form.valid || !validMobile || images.length === 0 || !isImageUploaded || loading"
					id="n77"
				>
					{{ locale.translations['place-ad']['n698'] }}
				</button>
			</div>
		</div>
		<!--STAGE 7 END-->
	</form>
	<canvas hidden="true" id="canvas" style="width: 100%; height: 10em; object-fit: cover"></canvas>
</div>
